'use strict';

(function ($) {
    $.widget('ui.agImageEditor', {

        _create: function () {

            var $element = $(this.element);

            this._on(this.element, {
                'click #EditImage': function (event) {

                    var imageId = this.element.find('input[type="hidden"]').val();
                    var url = this.element.attr('edit-url') + '?id=' + imageId + '&target=' + this.element.attr('control-id') + new Date().getTime();
                    
                    $.agito.hrmPage.loadDialog(url);
                }
            });
           
            this._on(this.element, {
                'click #RemoveImage': function (event) {

                    var image = this.element.find('.image-editor-image');
                    image.attr('src', this.element.attr('index-url'));

                    this.element.find('input[type="hidden"]').val('');
                    $(".image-editor-toolbox").html('<span id="EditImage" class="icon-agito-add-image" title="' + $.agito.resources.getResource("Shared_ImageEditor_Title") + '"></span><span style="left: 5px; bottom: 7px; position: relative;">' + $.agito.resources.getResource("Shared_ImageEditor_Title") + '</span>');
                }
            });
        },
    
        Update: function (imageId) {

            this.element.find('input[type="hidden"]').val(imageId);
            var url = this.element.attr('index-url') + '?id=' + imageId + '&target=' + this.element.attr('control-id') + new Date().getTime();
            var image = this.element.find('.image-editor-image');
            image.attr('src', url);

            if (imageId == null) {
                $(".image-editor-toolbox").html('<span id="EditImage" class="icon-agito-add-image" title="' + $.agito.resources.getResource("Shared_ImageEditor_Title") + '"></span><span style="left: 5px; bottom: 7px; position: relative;">' + $.agito.resources.getResource("Shared_ImageEditor_Title") + '</span>');
            }
            else {
                $(".image-editor-toolbox").html('<span id="EditImage" class="icon-agito-edit-image" title="' + $.agito.resources.getResource("Shared_ImageEditor_EditImage") + '"></span> <span id="RemoveImage" class="icon-agito-remove-image" title="' + $.agito.resources.getResource("Shared_ImageEditor_RemoveImage") + '"></span>');
            }

        }
    });
})($);